import { ROUTE } from "../constants/routes";
import { toast } from "../utils/toast";

export type LimitToastFeatureKey =
  | "maxActivities"
  | "maxBankAccounts"
  | "maxEvents"
  | "maxIncomingTransactions"
  | "maxIncomesPerMonth"
  | "maxInventoryItems"
  | "maxMembers"
  | "maxOutcomeTransactions"
  | "maxOutcomesPerMonth"
  | "maxRitualBaths";

export const LIMIT_REACHED_TOAST_MESSAGES: Record<LimitToastFeatureKey, string> =
  {
    maxActivities:
      "Você atingiu o limite de atividades do seu plano. Faça upgrade para adicionar mais atividades.",
    maxBankAccounts:
      "Você atingiu o limite de contas bancárias do seu plano. Faça upgrade para adicionar mais contas.",
    maxEvents:
      "Você atingiu o limite de eventos do seu plano. Faça upgrade para adicionar mais eventos.",
    maxIncomingTransactions:
      "Você atingiu o limite de contribuições do seu plano. Faça upgrade para adicionar mais contribuições.",
    maxIncomesPerMonth:
      "Você atingiu o limite de contribuições do seu plano. Faça upgrade para adicionar mais contribuições.",
    maxInventoryItems:
      "Você atingiu o limite de itens de inventário do seu plano. Faça upgrade para adicionar mais itens.",
    maxMembers:
      "Você atingiu o limite de membros do seu plano. Faça upgrade para adicionar mais membros.",
    maxOutcomeTransactions:
      "Você atingiu o limite de gastos do seu plano. Faça upgrade para adicionar mais gastos.",
    maxOutcomesPerMonth:
      "Você atingiu o limite de gastos do seu plano. Faça upgrade para adicionar mais gastos.",
    maxRitualBaths:
      "Você atingiu o limite de banhos rituais do seu plano. Faça upgrade para adicionar mais banhos.",
  };

const FALLBACK_LIMIT_TOAST_MESSAGE =
  "Você atingiu o limite do seu plano. Faça upgrade para continuar.";

type NotifyLimitReachedParams = {
  feature: LimitToastFeatureKey;
  message?: string;
  withUpgradeAction?: boolean;
};

const navigateToSettingsPlan = (): void => {
  const targetPath = ROUTE.SETTINGS_PLAN;

  if (typeof window === "undefined") {
    return;
  }

  if (window.location.pathname === targetPath) {
    return;
  }

  window.history.pushState({}, "", targetPath);
  window.dispatchEvent(new PopStateEvent("popstate"));
};

export const notifyLimitReached = ({
  feature,
  message,
  withUpgradeAction = true,
}: NotifyLimitReachedParams): void => {
  const normalizedCustomMessage = message?.trim();
  const toastMessage =
    (normalizedCustomMessage && normalizedCustomMessage.length > 0
      ? normalizedCustomMessage
      : LIMIT_REACHED_TOAST_MESSAGES[feature]) ?? FALLBACK_LIMIT_TOAST_MESSAGE;

  toast.warning(toastMessage, {
    duration: 8000,
    action: withUpgradeAction
      ? {
          label: "Ver planos",
          onClick: navigateToSettingsPlan,
        }
      : undefined,
  });
};
